import { TypeBoundAxiosInstance } from '@m43/core';
import { CadNextBootstrapView } from '@mark43/cad-api';
import { FetchUnAckedInProgressUnitEmergenciesForUser } from '@mark43/cad-api/dist/resources/UnitResource';

const CAD_BOOTSTRAP_EXCLUDE_FLAG_KEY = 'cadBootstrapExcludeUnackedInProgressUnitEmergenciesEnabled';

export const bootstrapUnitEmergencies = async (
    bootstrapView: CadNextBootstrapView,
    apiClient: TypeBoundAxiosInstance
): Promise<CadNextBootstrapView> => {
    const shouldExcludeFromBootstrap =
        bootstrapView.enabledFeatures[CAD_BOOTSTRAP_EXCLUDE_FLAG_KEY];

    if (!shouldExcludeFromBootstrap) {
        return bootstrapView;
    }

    try {
        const { data } = await apiClient.request<FetchUnAckedInProgressUnitEmergenciesForUser>({
            method: 'GET',
            url: 'unit/unit_emergency/unacked',
        });
        const unitEmergencyDtos = data?.data?.unitEmergencyDtos ?? [];

        return {
            ...bootstrapView,
            unAckedInProgressUnitEmergencies: unitEmergencyDtos,
        };
    } catch (err) {
        return bootstrapView;
    }
};
